import APIController from '../core-api-controller';

export const fetchRolesApi = (paramsObj = {}, paramsStr = '') => {
  const path = `${APIController.endpointApi}/roles${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const createRoleApi = (data = '') => {
  const path = `${APIController.endpointApi}/roles`;
  return APIController.postCallback(path, data);
};

export const editRoleApi = (data = '', roleId = '') => {
  const path = `${APIController.endpointApi}/roles/${roleId}`;
  return APIController.putCallback(path, data);
};

export const deleteRoleApi = (roleId = '') => {
  const path = `${APIController.endpointApi}/roles/${roleId}`;
  return APIController.deleteCallback(path);
};

export const fetchRoleDetailApi = (roleId = '') => {
  const path = `${APIController.endpointApi}/roles/${roleId}`;
  return APIController.getApiCallback(path);
};

export const fetchPermissionSkeletonApi = () => {
  const path = `${APIController.endpointApi}/role_permissions/fetch_premissions_skeleton`;
  return APIController.getApiCallback(path);
};
